<template>
  <div>
    <el-dialog
      title="查看包裹"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <el-table :data="data" border stripe>
        <el-table-column type="index" label="序号" width="50" align="center" />
        <el-table-column label="商品编码" prop="spuCode" align="center" />
        <el-table-column label="SKU编码" prop="skuCode" align="center" />
        <el-table-column label="商品名称" prop="spuName" align="center" show-overflow-tooltip />
        <el-table-column label="数量" prop="num" align="center" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose">{{ $t('cancelText') }}</el-button> -->
        <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BusinessOrderSourcePackageView',
  data() {
    return {
      data: [],
      dialogVisible: false,
    };
  },
  methods: {
    show(data) {
      this.data = data;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.hide();
    },
    /** 保存包裹 */
    confirm(data) {
      this.hide();
    },
  },
};
</script>

<style></style>
